import React from 'react';
import {
    Dropdown,
    Option,
    Field,
    Spinner,
    Text
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import RequiredLabel from './RequiredLabel';
import { InsertableArchiveResult } from '../../../services/api/dataServiceOutlookQuickSave';

interface ArchiveDropdownProps {
    archives: InsertableArchiveResult[];
    selectedArchive: InsertableArchiveResult | null;
    isLoading: boolean;
    error: string;
    disabled?: boolean;
    required?: boolean;
    onArchiveChange: (archive: InsertableArchiveResult | null) => void;
}

const ArchiveDropdown: React.FC<ArchiveDropdownProps> = ({
    archives,
    selectedArchive,
    isLoading,
    error,
    disabled = false,
    required = false,
    onArchiveChange
}) => {
    const { t } = useTranslation();

    const handleOptionSelect = (_event: unknown, data: { optionValue?: string }) => {
        const selectedArchiveRecno = data.optionValue;
        if (selectedArchiveRecno) {
            const archive = archives.find(a => a.Recno.toString() === selectedArchiveRecno);
            onArchiveChange(archive || null);
        } else {
            onArchiveChange(null);
        }
    };

    return (
        <Field
            label={<RequiredLabel text={t("Archive")} required={required} />}
            validationMessage={error || undefined}
            validationState={error ? "error" : "none"}
        >
            {isLoading ? (
                <div>
                    <Spinner size="small" />
                    <Text>{t("Loading...")}</Text>
                </div>
            ) : (
                <Dropdown
                    placeholder={t("Select an archive")}
                    value={selectedArchive?.Description || ''}
                    selectedOptions={selectedArchive ? [selectedArchive.Recno.toString()] : []}
                    onOptionSelect={handleOptionSelect}
                    disabled={disabled}
                >
                    {archives.map((archive) => (
                        <Option
                            key={archive.Recno}
                            value={archive.Recno.toString()}
                            text={archive.Description}
                        >
                            {archive.Description}
                        </Option>
                    ))}
                </Dropdown>
            )}
        </Field>
    );
};

export { ArchiveDropdown };
export default ArchiveDropdown;
